export enum FormArrayConfig {
  AutoAddField,
  DeleteLast,
  DeleteCustom,
}
